import axios from 'axios';
import { BACKEND_URL } from '../../../utils/index.js';

export const confirmPasswordLink = async (passwordLink) => {
    return axios.get(`${BACKEND_URL}/passwordLink/confirm/${passwordLink}`);
};

export const sendPasswordLink = async (email) => {
    return axios.post(`${BACKEND_URL}/passwordLink/${email}`);
};